import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField
} from "@material-ui/core";
import React, { useCallback, useMemo, useRef, useState } from "react";
import { TableHeaderColumn } from "react-bootstrap-table";
import { useDataFormatterHook } from "../../../hooks/useDataFormatterHook";
import Crud from "../Crud";
import axios from "axios"


/**
 * TABLE FREEPLAYOFFICEOPTIONS
 */
function Books() {
  const [openBookPrefix, setOpenBookPrefix] = React.useState(false);
  const onOpenBookPrefixChange = useCallback((open) => {
    setOpenBookPrefix(open);
  }, []);

  const [selectedBook, setSelectedBook] = React.useState(null);
  const onSeletedBookChanged = useCallback((book) => {
    setSelectedBook(book);
    setOpenBookPrefix(true);
  }, []);

  const { values: webColumns, formatter: webColumnsFormatter } =
    useDataFormatterHook({
      value: "idColumn",
      text: "description",
      path: "/WebConfigurator/WebColumn_GetList",
    });

  const userInfo = useMemo(
    () => JSON.parse(localStorage.getItem("userInfo")),
    []
  );
  const [open, setOpen] = useState(false);
  // const [newData, setNewData] = useState({ PreName: "", Consecutive: "" });
  const newDataRef = useRef({ PreName: "", Consecutive: "" });
  const [countFetch, setCountFetch] = useState(false)


  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    setOpen(false);
    newDataRef.current.PreName = "";
    newDataRef.current.Consecutive = "";
  };

  const handleChange = (e) => {
    newDataRef.current[e.target.name] = e.target.value;
  };

  const handleInsert = () => {
    const newItem = {
      IdBook: selectedBook.idBook,
      PreName: newDataRef.current.PreName,
      Consecutive: newDataRef.current.Consecutive,
      IdUser: Number(userInfo.userId),
    };

    axios.post(process.env.REACT_APP_API2_URL + "/Game/BookPrefix_Insert", newItem)
      .then(() => {

        handleClose();
      })
      .catch(error => console.error("Error:", error));

  };

  const getBookPrefixUrl = useCallback(() => {
    return `/Game/BookPrefix_GetList?idBook=${selectedBook.idBook}`;
  }, [selectedBook?.idBook]);

  return (
    <>
      <Dialog
        open={openBookPrefix}
        onClose={onOpenBookPrefixChange}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle>Book Prefix ({selectedBook?.bookName})</DialogTitle>
        <DialogContent>
          <Dialog open={open} onClose={handleClose} fullWidth maxWidth="xs">
            <DialogTitle style={{ border: "1px solid #dee2e6" }}>Insert Book Prefix</DialogTitle>
            <DialogContent>
              <TextField
                label="Prefix Name"
                name="PreName"
                // value={newData.PreName}
                defaultValue={newDataRef.current.PreName}
                onChange={handleChange}
                fullWidth
                margin="dense"
              />
              <TextField
                label="Consecutive"
                name="Consecutive"
                // value={newData.Consecutive}
                defaultValue={newDataRef.current.Consecutive}
                onChange={handleChange}
                fullWidth
                margin="dense"
              // disabled
              />
            </DialogContent>
            <DialogActions>
              <button onClick={handleClose} color="secondary" className="btn btn-secondary">
                Cancel
              </button>
              <button onClick={handleInsert} color="primary" className="btn btn-primary">
                Insert
              </button>
            </DialogActions>
          </Dialog>
          <Crud
            getUrl={getBookPrefixUrl}
            getProcess={(data) =>
              data.map((item) => ({
                ...item,
                id: `${item.idBook}-${item.preName}`,
              }))
            }
            // INSERT
            insertUrl={() => "/Game/BookPrefix_Insert"}
            // insertParams={({ userId }, { PreName, Consecutive }) => ({
            //   IdBook: selectedBook.idBook,
            //   PreName,
            //   Consecutive,
            //   IdUser: Number(userId),
            // })}
            // DELETE
            deleteUrl={() => "/Game/BookPrefix_Delete"}
            deleteParams={({ userId }, _, { preName }) => ({
              IdBook: selectedBook.idBook,
              PreName: preName,
              IdUser: Number(userId),
            })}
            openModal={handleOpen}
          >
            <TableHeaderColumn
              visible="none"
              hiddenOnInsert
              autoValue={true}
              hidden
              isKey
              dataField="id"
            >
              Id
            </TableHeaderColumn>
            <TableHeaderColumn
              visible="none"
              hiddenOnInsert
              hidden
              dataField="idBook"
            >
              Id
            </TableHeaderColumn>
            <TableHeaderColumn
              dataField="preName"
              filter={{ type: "TextFilter", delay: 1000 }}
            >
              Prefix Name
            </TableHeaderColumn>
            <TableHeaderColumn
              dataField="consecutive"
              filter={{ type: "TextFilter", delay: 1000 }}
            >
              Consecutive
            </TableHeaderColumn>
          </Crud>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => onOpenBookPrefixChange(false)}
            color="secondary"
            variant="contained"
            autoFocus
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
      <Crud
        title="Books"
        getUrl={({ userId }) => `/Game/Book_GetList?idUser=${userId}`}
        // INSERT
        insertUrl={() => "/Game/Book_Insert"}
        insertParams={({ userId }, { bookName, idWebColumn }) => ({
          Name: bookName,
          IdWebColumn: idWebColumn,
          IdUser: Number(userId),
        })}
        // UPDATE
        updateUrl={() => "/Game/Book_Update"}
        updateParams={({ userId }, { idBook, bookName, idWebColumn }) => ({
          IdBook: idBook,
          Name: bookName,
          IdWebColumn: idWebColumn,
          IdUser: Number(userId),
        })}
        // DELETE
        deleteUrl={() => "/Game/Book_Delete"}
        deleteParams={({ userId }, id) => ({
          IdBook: id,
          IdUser: Number(userId),
        })}
      >
        <TableHeaderColumn
          visible="none"
          hiddenOnInsert
          autoValue={true}
          hidden
          isKey
          dataField="idBook"
        >
          Id
        </TableHeaderColumn>
        <TableHeaderColumn
          dataField="bookName"
          filter={{ type: "TextFilter", delay: 1000 }}
        >
          Name
        </TableHeaderColumn>
        <TableHeaderColumn
          dataField="idWebColumn"
          filter={{ type: "TextFilter", delay: 1000 }}
          dataFormat={webColumnsFormatter}
          editable={{ type: "select", options: { values: webColumns } }}
        >
          Web Column
        </TableHeaderColumn>
        <TableHeaderColumn
          hiddenOnInsert
          autoValue={true}
          filter={{ type: "TextFilter", delay: 1000 }}
          dataFormat={(_, book = {}) => (
            <i
              onClick={() => onSeletedBookChanged(book)}
              className="fa-solid fa-pencil"
            ></i>
          )}
        >
          Book Prefix
        </TableHeaderColumn>
      </Crud>
    </>
  );
}

export default Books;
